<template>
  <div>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>

    <!-- Data table -->
    <v-card>
     <v-card-title>
          <v-row>
              <v-col cols="12" md="4" sm="12"></v-col>

              <v-col cols="6" md="2" sm="6">
                  <v-menu
                      v-model="menuDateFrom"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="from_date"
                              :label="$t('dateFrom')"
                              prepend-inner-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                          ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="from_date"
                          @input="menuDateFrom = false"
                      ></v-date-picker>
                  </v-menu>
              </v-col>

              <v-col cols="6" md="2" sm="6">

                  <v-menu
                      v-model="menuDateTo"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="to_date"
                              :label="$t('dateTo')"
                              prepend-inner-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                          ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="to_date"
                          @input="menuDateTo = false"
                      ></v-date-picker>
                  </v-menu>
              </v-col>

              <v-col cols="6" md="2" sm="6">
                  <v-text-field
                      v-model="search"
                      :label="$t('search')"
                      single-line
                      outlined
                      dense
                      clearable
                  >
                  </v-text-field>
              </v-col>

              <v-col cols="12" md="2" sm="12">
                  <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
                      <v-icon class="mr-1"> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn @click="exportExcel('exportExcel')" outlined>
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
                  </v-btn>
              </v-col>
          </v-row>
      </v-card-title>

      <v-data-table
        id="exportExcel"
        :loading="loading"
        :headers="headers"
        :items="stockTransferList"
        :search="search"
        hide-default-footer
        class="elevation-1"
        :server-items-length="totalPage"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        :options.sync="options"
        :mobile-breakpoint="0"
      >
        <!-- Progressive -->
        <template v-slot:progress style="text-align: center"><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

        <!-- Header -->
        <template v-slot:header.date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.from_contact_name="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.to_contact_name="{ header }"> {{ isBeeOperator ? $t(header.text) : ''}}</template>
        <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.paid_amount="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.paymentStatus="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.status="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

        <!-- Body -->
        <template v-slot:item.date="{ item }">{{ item.date | dateFormat}}</template>
        <template v-slot:item.to_contact_name="{ item }"> {{ isBeeOperator ? item.to_contact_name : '' }}</template>
        <template v-slot:item.total_amount="{ item }">{{ parseFloat(item.total_amount) | formatNumber }}{{ getCurrencySymbol(item.currency_code) }}</template>
        <template v-slot:item.paid_amount="{ item }">{{ parseFloat(item.paid_amount) | formatNumber }}{{ getCurrencySymbol(item.currency_code) }}</template>
        <template v-slot:item.status="{ item }"><v-chip small outlined :color="getColor(item.status)" dark>{{ $t(item.status) }}</v-chip></template>
        <template v-slot:item.payment_status="{ item }"><v-chip small outlined :color="getColor(item.payment_status)" dark>{{ $t(item.payment_status) }}</v-chip></template>

        <!-- Action -->
        <template v-slot:item.action="{ item }">

          <v-btn color="primary" small rounded class="table-action-button no-text-transform mr-2" v-if="item.payment_status !== 'paid' && item.status == 'accepted'" @click="handlePayment(item.id, item.to_contact_id, $event)"><font-awesome-icon icon="dollar-sign" class="mr-1"/> {{ $t('payment') }}</v-btn>
          <v-btn color="success" small rounded depressed class="table-action-button mr-1" text v-if="item.status==='transfer'" :disabled="item.status!=='transfer'" @click.native="handleEdit(item,$event,true)">{{ $t('receive')}}</v-btn>
          <v-btn color="success" outlined class="table-action-button" text icon :to="{ name: 'beeshop.agri-input.stock-transfer.stock-transfer-print', params: { id: item.id, transfer_status: 'forAccept'}}"><font-awesome-icon icon="print"/></v-btn>
        </template>

      </v-data-table>

      <div class="text-center pt-2">
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-col
              v-if="!$vuetify.breakpoint.xsOnly"
              class="d-flex"
              cols="12"
              sm="1"
          >
            {{ $t("total") }} : {{ totalPage }}
          </v-col>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >
            <v-select
                :label="$t('perPage')"
                v-model="itemsPerPage"
                :items="pageList"
            ></v-select>
          </v-col>

          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
          ></v-pagination>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >

            <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
            ></v-text-field>
          </v-col>
        </v-card-actions>
      </div>
    </v-card>
    <!-- End Data table -->

    <!-- Form control -->
    <v-form v-model="valid" ref="formData" lazy-validation>
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline">{{$t("receiveStockTransfer")}}</span>
            <v-spacer></v-spacer>
            <v-btn fab text icon @click="handleClose()" v-shortkey="['esc']" @shortkey.native="handleClose()"><font-awesome-icon style="font-size: 20px;color: white" icon="times"/></v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                        v-model="formDoc.from_contact_id"
                        :items="clientOptionList"
                        outlined
                        :dense="dense"
                        auto-select-first
                        item-text="text"
                        item-value="id"
                        :label="$t('from') + '*'"
                        :rules="selectRules"
                        required
                        :disabled="true"
                    >
                      <template v-slot:selection="{ item }">{{ item.company_name || item.text }}: {{ $t(item.type) }}</template>
                      <template v-slot:item="{ item }">{{ item.company_name || item.text }} : {{ item.mobile }} ( {{ $t(item.type) }} )</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" v-if="isBeeOperator">
                    <v-autocomplete
                        v-model="formDoc.to_contact_id"
                        :items="clientOptionList"
                        outlined
                        :dense="dense"
                        auto-select-first
                        item-text="text"
                        item-value="id"
                        :label="$t('to') + '*'"
                        :rules="selectRules"
                        required
                        :disabled="true"
                    >
                      <template v-slot:selection="{ item }">{{ item.company_name || item.text }}: {{ $t(item.type) }}</template>
                      <template v-slot:item="{ item }">{{ item.company_name || item.text }} : {{ item.mobile }} ( {{ $t(item.type) }} )</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="currencyOptionList"
                      :label="$t('currency') + '*'"
                      outlined
                      v-model="formDoc.currency_code"
                      :disabled="true"
                      :rules="selectRules"
                      item-text="text"
                      item-value="id"
                      dense
                    >

                      <template v-slot:selection="{ item }">{{ item.text }}</template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      v-model="menuDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :disabled="true"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formDoc.date"
                          :label="$t('transferDate') + '*'"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          dense
                          readonly
                          :rules="dateRules"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="formDoc.date"
                          :rules="dateRules"
                          @input="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="formDoc.reference"
                      :label="$t('reference')"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              
              <v-col cols="12" sm="9" md="9">
                <v-row>
              
                  <v-col cols="12" md="12" sm="12">
                    <v-data-table
                      :headers="stockTransferHeader"
                      :items="transaction_transfer_line"
                      hide-default-footer
                      mobile-breakpoint="0"
                    >
                      <template v-slot:header.product_name="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.transfer_qty="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.product_description="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.amount="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:item.transfer_qty="{ item }">
                        <v-text-field
                          style="min-width: 150px"
                          :disabled="true"
                          type="number"
                          v-model="item.transfer_qty"
                          hide-details="auto"
                          :suffix="item.unit_name"
                          dense
                        ></v-text-field>
                      </template>
                      <template v-slot:item.product_description="{ item }">
                        {{
                          item.product_description && item.product_description.substr(0, 9) || ""
                        }}{{
                          item.product_description && item.product_description.length > 9 ?
                              "..." : ""
                        }}
                      </template>
                      <template v-slot:item.price="{ item }">{{ item.price | formatNumber }}{{ item.currency_symbol }}</template>
                      <template v-slot:item.amount="{ item }">{{ item.amount | formatNumber }}{{ item.currency_symbol }}</template>
                    </v-data-table>
                  </v-col>

                  <v-col sm="8" cols="2" style="text-align: right;"><h3>{{ $t("totalAmount") }} :</h3></v-col>
                  <v-col
                    cols="10"
                    sm="4"
                    style="background-color: lightgray;font-weight: bold;font-size: 25px"
                  >
                    {{ formDoc.total_amount | formatNumber }}{{ currency_symbol }}
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                        clearable
                        v-model="formDoc.note"
                        clear-icon="mdi-close-circle"
                        rows="4"
                        outlined
                        :placeholder="$t('yourDesc')"
                        auto-grow
                        :label="$t('note')"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn rounded @click="acceptStock($event,formDoc.id)" style="min-width: 150px" color="success"><font-awesome-icon icon="check-circle" class="mr-2"/>{{$t('receive')}}</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </v-form>


    <!-- Payment section -->
      <receive-payment></receive-payment>
    <!-- End Payment section -->
  </div>
</template>
<script>
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import receivePayment from './receivePayment';

import moment from "moment";
import {provider} from "@/service/provider";
import axios from "axios";
import _ from "lodash";

export default {
  name: "stockTransferReceive",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  components: {receivePayment},
  data() {
    return {
      formDoc: {
        id: "",
        from_contact_id: "",
        to_contact_id: "",
        currency_code: "",
        date: moment().format("YYYY-MM-DD"),
        note: "",
        reference: "",
        status: "transfer",
        total_amount: 0,
        user_id: ""
      },
      filterDoc: {
        product_id: "",
        category_id: ""
      },
      headers: [
        {
          text: "transferDate",
          align: "start",
          value: "date"
        },
        {text: "reference", value: "reference"},
        {text: "from", value: "from_contact_name", sortable: false},
        {text: "to", value: "to_contact_name", sortable: false},
        {text: "totalAmount", value: "total_amount"},
        {text: "paid_amount", value: "paid_amount"},
        {text: "status", value: "status"},
        {text: this.$t("paymentStatus"), value: "payment_status"},
        {text: "action", value: "action", sortable: false, width: 100}
      ],
      transaction_transfer_line: [],
      stockTransferHeader: [
        {
          text: "productName",
          align: "start",
          sortable: false,
          value: "product_name"
        },
        {text: "transfer_qty", value: "transfer_qty", width: 150, sortable: false},
        {text: "price", value: "price", sortable: false},
        {text: "amount", value: "amount", sortable: false},
        {text: "note", value: "product_description"},
      ],
      currency_symbol: "",
      filterStatus: "",
    };
  },
  methods: {
   
    handleClose() {
      this.dialog = false;
      this.reset();
    },
    
    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchStockTransfer({
        transfer_status: 'forAccept',
        search: vm.search,
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0] === false ? 0 : 1,
        from_date: vm.from_date,
        to_date: vm.to_date,
      })
    }, 350),

    handleEdit(item, event) {
      event.preventDefault();
      let vm = this;
      vm.formDoc = {};
      vm.overlay = true;
      vm.fetchClientOption();
      vm.fetchCurrencyOption();

      vm.toggleAdd = false;
      let url = provider.baseURL + provider.getStockTransfer;
      return new Promise((resolve, reject) => {
        axios.post(url, {
          transfer_status: 'forAccept',
          search: "",
          id: item.id,
          offset: 0,
          sort_by: "",
          sort_desc: 0,
          limit: 1
        }, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                vm.overlay = false;
                vm.dialog = true;
                resolve(res.data.data);
                let newItem = res.data.data[0];

                vm.filterDoc.category_id = "";
                vm.filterDoc.product_id = "";
                vm.formDoc = Object.assign({}, newItem);

                vm.formDoc.total_amount = parseFloat(vm.formDoc.total_amount);
                vm.formDoc.date = vm.parseFromDate(vm.formDoc.date);
                vm.transaction_transfer_line = [];
                vm.transaction_transfer_line.push(...newItem.transaction_transfer_line);

                vm.transaction_transfer_line.map((d) => {
                  d.currency_code = vm.formDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                  d.transfer_qty = parseFloat(d.transfer_qty);
                  d.price = parseFloat(d.price);
                  d.amount = parseFloat(d.amount);
                  return d;
                })
              }
            },
            error => {
              reject(error);
            }
        );
      });


    },

    acceptStock(event,id) {
      event.preventDefault();
      let vm = this;
      let url = provider.baseURL + provider.acceptStockTransfer;
      let selector = {};
      selector.id = id;
      selector.accepted_by_id = this.isBeeOperator ? this.formDoc.to_contact_id : vm.$store.state.userDoc.contact_id
      selector.accepted_date = moment().format("YYYY-MM-DD");
      return new Promise((resolve, reject) => {
        axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('success')
                });
                vm.fetchDataTable();
                vm.dialog = false;

              }
            },
            error => {
              reject(error);
            }
        );
      });
    },
  
    calculateTotal() {
      let vm = this;
      vm.formDoc.total_amount = 0;
      vm.transaction_transfer_line.forEach((obj) => {
        vm.formDoc.total_amount += parseFloat(obj.amount);
      })
    },

    handlePayment(transaction_id, client_id){
      this.$store.dispatch('updateTransferDialogPayment', {dialog: true, transaction_id: transaction_id, client_id: client_id});
    },

    handleSearch(){
      this.fetchDataTable();
    }

  },

  computed: {
    isBeeOperator() {
      return ['beeOperator', 'employee'].includes(this.$store.state.userDoc.type);
    },
    dialogPayment(){
      return this.$store.state.transfer.dialog;
    },
  },
  watch: {
    dialogPayment(val) {
      if (val === false) { 
        this.fetchDataTable();
      }
    },

    filterStatus() {
      this.fetchDataTable();
    },
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    dialog(val) {
      if (val === false) {
        this.reset();
      }
    }
  },
  created() {}
};
</script>
